import { Spin } from 'antd';
import { RadarChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Config {
  filled?: boolean;
}
interface Data {
  indicators: Array<{ name: string; max: number }>;
  series: Array<{ name: string; data: number[] }>;
}

function RadarWidget({ instance }: WidgetRenderProps<Config>) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'radar', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <RadarChart indicators={data?.indicators ?? []} series={data?.series ?? []} filled={instance.config.filled} />;
}

export const radarWidgetDef: WidgetDefinition<Config> = {
  type: 'radar',
  name: 'Radar Chart',
  description: 'Multidimensional comparison',
  icon: 'RadarChartOutlined',
  category: 'chart',
  defaultTitle: 'Radar Chart',
  defaultConfig: { filled: true },
  minW: 4, minH: 4, defaultW: 5, defaultH: 6,
  component: RadarWidget,
  settingsSchema: { fields: [{ key: 'filled', label: 'Filled', type: 'boolean' }] },
};
